<template>
  <WsRead
    localeMode
    titleKey="name"
    :modelName="modelName"
    :id="$route.params.id"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
  />
</template>

<script>
import model from '@/models/alliance';

export default {
  data() {
    return {
      modelName: model.modelName,
      label: model.label,
      fields: model.fields,
      pageSetting: {
        primary: [
          {
            type: 'infoCard',
            floors: [
              {
                fields: [
                  'locales',
                  'remark',
                  'logo',
                  'related_modules',
                ],
              },
            ],
          },
        ],
        secondary: [
          {
            type: 'infoCard',
            floors: [
              {
                fields: [
                  'area',
                ],
              },
            ],
          },
          {
            type: 'infoCard',
            floors: [
              {
                title: '建立資訊',
                fields: ['created_at', 'created_admin'],
              },
            ],
          },
          {
            type: 'infoCard',
            floors: [
              {
                title: '編輯資訊',
                fields: ['updated_at', 'updated_admin'],
              },
            ],
          },
        ],
      },
    };
  },
};
</script>